export default "/images/video-player.png?f2bff912dfe9aeee884da47a8264f82e";